let module = angular.module('app.resources');

module.factory('Caption', ($resource) => {
  'ngInject';
  return $resource(
    `${API_ROOT}/account/broadcasts/:broadcast_id/captions/:id`,
    { broadcast_id: '@broadcast_id', id: '@id' },
    {
      query: {
        method: 'GET',
        isArray: true,
      },
      create: { method: 'POST' },
      delete: { method: 'DELETE' },
      update: { method: 'PUT' },
      render: {
        method: 'GET',
        params: {
          type: '@format',
        },
        url: `${API_ROOT}/account/broadcasts/:broadcast_id/captions/:id/render?format=:format`,
        responseType: 'arraybuffer',
        transformResponse: function (data, headers) {
          return { blob: new Blob([data], { type: headers('Content-Type') }) };
        },
      },
    }
  );
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/caption.js